/**
 * Legal route paths.
 *
 * Kept in their own module so the router can decide whether a URL is a policy
 * page without importing the (lazily loaded) page component and its content.
 */
export const LEGAL_ROUTES = ['/privacy-policy', '/terms', '/refund-policy', '/contact'];
